<template>
  <nuxt-link :to="url">
    <span class="icon-container">
      <icon class="icon" name="nomad:back" size="1.2rem" />
      <icon class="icon over" name="nomad:back" size="1.2rem" />
    </span>

    <span>{{ label }}</span>
  </nuxt-link>
</template>
<script setup lang="ts">
interface Props {
  links: Links;
}

const props = defineProps({
  links: null
});

const route = useRoute();

const label = computed(() => {
  if (!props.links.length) return 'Retour';
  return props.links.length >= 2
    ? `${props.links[0].label} - ${props.links[1].label}`
    : `${props.links[0].label}`;
});

const baseUrl = computed(() => {
  const parts = route.path.split('/');
  return parts.length > 2 ? `/${parts[1]}` : '/';
});

const url = computed(() => {
  const currentPath = route.path;
  const backLinks = [...props.links].reverse();
  const backLink = backLinks.find((link) => {
    return link.url !== currentPath;
  });
  return backLink?.url || baseUrl.value;
});
</script>
<style lang="scss" scoped>
a {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  width: fit-content;
  padding: var(--gap_n);
  border-width: var(--stroke_thickness_s);
  border-style: solid;
  border-radius: 2rem;
  border-color: var(--color_secondary_lighter);
  background-color: var(--color_neutral_25);
  color: var(--color_secondary_darker);
  text-align: left;
  gap: var(--gap_s);
  @include font('s', 500, 'secondary');
  @include above('l') {
    width: 100%;
  }
  &.main {
    color: var(--color_secondary);
  }
  .icon-container {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 2.2rem;
    height: 2.2rem;
    overflow: hidden;
    border-radius: 50%;
    background-color: var(--color_secondary_lighter);
  }
  .icon {
    position: relative;
    z-index: 1;
    width: 1.2rem;
    color: var(--color_secondary_darker);
    &.over {
      position: absolute;
      top: calc(0.5 * (2.2rem - 1.2rem));
      left: calc(2.2rem + 0.5 * (2.2rem - 1.2rem));
      color: var(--color_neutral_25);
    }
  }

  &:hover,
  &:focus,
  &.active,
  &.router-link-active,
  &.router-link-exact-active-with-hash {
    @include pointer-desktop {
      .icon-container {
        transition: background-color 200ms $ease-in-quad;
        background-color: var(--color_secondary);
        color: var(--color_neutral_25);
      }

      color: var(--color_secondary);

      .icon {
        transform: translateX(-2.2rem);
        transition: transform 200ms $ease-in-quad;

        &.over {
          transform: translateX(-2.2rem);
          transition: transform 200ms $ease-out-back 100ms;
        }
      }

      &.main {
        color: var(--color_secondary);
      }
    }
  }
}
</style>
